// import { notificationStore } from '@/features/notifications/stores/notification.store';
import { notificationStore } from '@/features/notifications/stores/new-notification.store';
import { error as logError } from '@/utils/logger';

const defaultOptions = {
  icon: '/assets/png/nolimit-care.png',
  badge: '/assets/png/nolimit-care.png',
};

/**
 * Navigate to a URL without full page refresh using client-side routing
 * Uses History API to update the URL, which React Router will detect
 */
export const navigateToUrl = (url: string) => {
  try {
    const urlObj = new URL(url, window.location.origin);

    // Check if it's a same-origin URL
    if (urlObj.origin !== window.location.origin) {
      // External URL, use full page refresh
      window.location.href = url;
      return;
    }

    const pathname = urlObj.pathname;
    const search = urlObj.search;
    const hash = urlObj.hash;
    const fullPath = pathname + search + hash;

    // Use History API to navigate without refresh
    // React Router's BrowserRouter listens to popstate events and location changes
    window.history.pushState({}, '', fullPath);

    // Manually trigger a popstate event to ensure React Router picks up the change
    // This is necessary because pushState doesn't automatically fire popstate
    const popStateEvent = new PopStateEvent('popstate', { state: {} });
    window.dispatchEvent(popStateEvent);
  } catch (err) {
    // Fallback to full page refresh if URL parsing fails
    logError('Failed to parse URL for client-side navigation', err);
    window.location.href = url;
  }
};

interface NotifyOptions {
  data?: {
    url?: string;
    receiverId?: string;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

export const notify = async (title: string, body: string, options: NotifyOptions = {}) => {
  const {
    isOnBrowserNotification,
    actions: { setIsOnBrowserNotification },
  } = notificationStore.getState();

  if (!('Notification' in window)) {
    // Check if the browser supports notifications
    alert('This browser does not support desktop notification!');
  } else if (Notification.permission === 'granted') {
    // Check whether notification permissions have already been granted;
    // if so, create a notification
    if (!isOnBrowserNotification) {
      setIsOnBrowserNotification(true);
    }

    // If current tab is visible/focused, prefer in-app toast over system notification
    // const isTabActive = document.visibilityState === 'visible' || document.hasFocus();

    // if (isTabActive) {
    //   toast.info(`${title}${body ? ` — ${body}` : ''}`, {
    //     onClick: () => {
    //       window.focus();
    //       if (options?.data?.url) {
    //         window.location.href = options.data.url;
    //       }
    //     },
    //   });
    //   return;
    // }

    const notification = new Notification(title, {
      body,
      ...defaultOptions,
      ...options,
    });

    // Handle notification click
    notification.onclick = () => {
      window.focus();
      notification.close();

      // Navigate to URL if provided in data
      if (options?.data?.url) {
        navigateToUrl(options.data.url);
      }
    };

    // …
  } else if (Notification.permission !== 'denied') {
    // We need to ask the user for permission
    await Notification.requestPermission().then((permission) => {
      // If the user accepts, let's create a notification
      if (permission === 'granted') {
        if (!isOnBrowserNotification) {
          setIsOnBrowserNotification(true);
        }

        // If current tab is visible/focused, prefer in-app toast over system notification
        // const isTabActive = document.visibilityState === 'visible' || document.hasFocus();

        // if (isTabActive) {
        //   toast.info(`${title}${body ? ` — ${body}` : ''}`, {
        //     onClick: () => {
        //       window.focus();
        //       if (options?.data?.url) {
        //         window.location.href = options.data.url;
        //       }
        //     },
        //   });
        //   return;
        // }

        const notification = new Notification(title, {
          body,
          ...defaultOptions,
          ...options,
        });

        // Handle notification click
        notification.onclick = () => {
          window.focus();
          notification.close();

          // Navigate to URL if provided in data
          if (options?.data?.url) {
            navigateToUrl(options.data.url);
          }
        };

        // …
      }
    });
  }
};
